// extracted by mini-css-extract-plugin
export var headerProfileContainer = "Header-module--header-profile-container--159e7";
export var headerSearchContainer = "Header-module--header-search-container--d0cdc";
export var homepageText = "Header-module--homepage-text--3459c";
export var logoLinkContainer = "Header-module--logo-link-container--fc2ff";
export var mainHeader = "Header-module--main-header--857b7";
export var profilePlaceholder = "Header-module--profile-placeholder--ac037";